import { IIcon } from '../types/icon';

export const commonIcons: IIcon = {
  account: 'account',
  add: 'add',
  amex: 'amex',
  applepay: 'applepay',
  arrowUp: 'arrowUp',
  back: 'back',
  bkCrown: 'noop',
  calendar: 'calendar',
  cart: 'cart',
  catering: 'catering',
  cateringBirthday: 'cateringBirthday',
  cateringTwo: 'cateringTwo',
  check: 'check',
  checkCircle: 'checkCircle',
  circlePlus: 'circlePlus',
  close: 'close',
  cluckNorris: 'noop',
  cluckNorrisLoveThatChicken: 'noop',
  cluckNorrisSaxophone: 'noop',
  coffeeCupFilled: 'coffeeCupFilled',
  combo: 'noop',
  communicationPref: 'communicationPref',
  crowd: 'crowd',
  curbside: 'curbside',
  deleteAccount: 'deleteAccount',
  deleteCredit: 'deleteCredit',
  delivery: 'delivery',
  desserts: 'desserts',
  dineIn: 'dineIn',
  discover: 'discover',
  drinks: 'drinks',
  drive: 'drive',
  driveThru: 'driveThru',
  edit: 'edit',
  editWithEraser: 'editWithEraser',
  endered: 'endered',
  error: 'error',
  facebook: 'facebook',
  familyMeals: 'noop',
  fastFood: 'fastFood',
  favorite: 'favorite',
  favoriteFill: 'favoriteFill',
  fhsRewards: 'noop',
  gear: 'gear',
  googlePay: 'googlePay',
  home: 'home',
  help: 'help',
  halal: 'halal',
  hotDrink: 'hotDrink',
  info: 'info',
  instagram: 'instagram',
  invitationCode: 'invitationCode',
  kidsMeal: 'noop',
  kioskCard: 'kioskCard',
  language: 'language',
  list: 'list',
  listAlt: 'listAlt',
  location: 'location',
  lock: 'lock',
  lockUnlocked: 'lockUnlocked',
  logo: 'noop',
  loyaltyCard: 'noop',
  map: 'map',
  mapleLeaf: 'noop',
  mapleLeafFilled: 'noop',
  mastercard: 'mastercard',
  mbway: 'mbway',
  menu: 'menu',
  mobile: 'mobile',
  mobileNavHome: 'noop',
  new: 'WhatsNewIcon',
  next: 'next',
  offer: 'offer',
  order: 'noop',
  payback: 'payback',
  paypal: 'paypal',
  paymentCard: 'paymentCard',
  paymentCash: 'paymentCash',
  plkRewards: 'noop',
  poppyBag: 'poppyBag',
  preferences: 'preferences',
  previous: 'previous',
  profile: 'profile',
  qr: 'qr',
  mobileRaggedEdge: 'noop',
  desktopRaggedEdge: 'noop',
  refresh: 'refresh',
  remove: 'remove',
  requestInfo: 'requestInfo',
  restaurant: 'restaurant',
  rewards: 'noop',
  sadFace: 'sadFace',
  sandwiches: 'sandwiches',
  sauces: 'sauces',
  scanRewards: 'noop',
  seafood: 'noop',
  search: 'search',
  select: 'select',
  settings: 'settings',
  sides: 'noop',
  signatureChicken: 'noop',
  sodiumFlag: 'sodiumFlag',
  store: 'store',
  storeThree: 'storeThree',
  storeTwo: 'storeTwo',
  storeMarker: 'noop',
  submitFeedback: 'submitFeedback',
  swap: 'swap',
  telephone: 'telephone',
  tendersAndWings: 'noop',
  tiktok: 'tiktok',
  time: 'time',
  visa: 'visa',
  visibility: 'visibility',
  visibilityOff: 'visibilityOff',
  voice: 'voice',
  twitter: 'twitter',
  warning: 'warning',
  youtube: 'youtube',
  errorFilled: 'errorFilled',
  locationOff: 'locationOff',
  motorcycleHelmet: 'motorcycleHelmet',
  nightlight: 'nightlight',
  thunderstorm: 'thunderstorm',
  traffic: 'traffic',
  people: 'people',
};
